/**
 * レシピを別のメニューへ写す（試用・2026-10-07）— 大盛・小盛・セット違いを、このレシピから作る。
 * 写るのは材料と重量・1 食の重量・アレルゲン・根拠だけ。栄養成分の値は写らない（写した先で重量を直して計算し直す）。
 */
import { useEffect, useState } from "react";
import { api, type CatalogItem } from "../api";
import { navigate } from "../router";

export function CopyRecipe({ entryId, excludeProductId }: { entryId: string; excludeProductId: number | null }) {
  const [q, setQ] = useState("");
  const [hits, setHits] = useState<CatalogItem[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const query = q.trim();
    if (!query) return setHits([]);
    const t = setTimeout(() => {
      void api.catalog({ q: query, limit: 8 }).then((r) => r.ok && setHits(r.data.items.filter((i) => i.productId !== excludeProductId)));
    }, 250);
    return () => clearTimeout(t);
  }, [q, excludeProductId]);

  const copy = async (productId: number) => {
    setError(null);
    const r = await api.copyRecipe(entryId, productId);
    if (!r.ok) return setError(r.error);
    navigate(`/entries/${r.data.id}`);
  };

  return (
    <details className="card">
      <summary>
        <strong>このレシピを別のメニューへ写す</strong> <span className="badge trial">試用</span>{" "}
        <span className="muted small">大盛・小盛・セット違いを作るとき</span>
      </summary>
      <div className="stack">
        <p className="muted small">写した先では、材料の重量（ごはんの量など）を直して計算し直してください。栄養成分の値は写りません。</p>
        <div className="ingredient-search">
          <input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="写す先のメニューを探す（例: 大盛）" aria-label="写す先のメニューを探す" />
          {hits.length > 0 && (
            <ul className="hits">
              {hits.map((h) => (
                <li key={h.productId}>
                  <button type="button" onClick={() => void copy(h.productId)}>
                    <span>{h.name}</span>
                    <span className="muted small">この品へ写す</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
        {error && <p className="error">{error}</p>}
      </div>
    </details>
  );
}
